import { render, staticRenderFns } from "./TicketTypeStats.vue?vue&type=template&id=ced37cb2&scoped=true"
import script from "./TicketTypeStats.vue?vue&type=script&lang=js"
export * from "./TicketTypeStats.vue?vue&type=script&lang=js"
import style0 from "./TicketTypeStats.vue?vue&type=style&index=0&id=ced37cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced37cb2",
  null
  
)

export default component.exports